/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const Star052 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2004_848)">
        <path
          d="M10.0001 1.66663L8.9155 6.00495C8.70386 6.8515 8.59804 7.27477 8.37765 7.6192C8.18271 7.92386 7.92398 8.18259 7.61932 8.37753C7.2749 8.59792 6.85162 8.70374 6.00507 8.91538L1.66675 9.99996L6.00507 11.0845C6.85162 11.2962 7.2749 11.402 7.61932 11.6224C7.92398 11.8173 8.18271 12.0761 8.37765 12.3807C8.59805 12.7251 8.70386 13.1484 8.9155 13.995L10.0001 18.3333L11.0847 13.995C11.2963 13.1484 11.4021 12.7251 11.6225 12.3807C11.8175 12.0761 12.0762 11.8173 12.3808 11.6224C12.7253 11.402 13.1485 11.2962 13.9951 11.0845L18.3334 9.99996L13.9951 8.91538C13.1485 8.70374 12.7253 8.59792 12.3808 8.37753C12.0762 8.18259 11.8175 7.92386 11.6225 7.6192C11.4021 7.27477 11.2963 6.8515 11.0847 6.00495L10.0001 1.66663Z"
          stroke="url(#paint0_linear_2004_848)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M10.0001 1.66663L8.9155 6.00495C8.70386 6.8515 8.59804 7.27477 8.37765 7.6192C8.18271 7.92386 7.92398 8.18259 7.61932 8.37753C7.2749 8.59792 6.85162 8.70374 6.00507 8.91538L1.66675 9.99996L6.00507 11.0845C6.85162 11.2962 7.2749 11.402 7.61932 11.6224C7.92398 11.8173 8.18271 12.0761 8.37765 12.3807C8.59805 12.7251 8.70386 13.1484 8.9155 13.995L10.0001 18.3333L11.0847 13.995C11.2963 13.1484 11.4021 12.7251 11.6225 12.3807C11.8175 12.0761 12.0762 11.8173 12.3808 11.6224C12.7253 11.402 13.1485 11.2962 13.9951 11.0845L18.3334 9.99996L13.9951 8.91538C13.1485 8.70374 12.7253 8.59792 12.3808 8.37753C12.0762 8.18259 11.8175 7.92386 11.6225 7.6192C11.4021 7.27477 11.2963 6.8515 11.0847 6.00495L10.0001 1.66663Z"
          stroke="url(#paint1_linear_2004_848)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="0.16"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2004_848"
          x1="-5.9463"
          x2="10.2402"
          y1="10.2401"
          y2="26.4265"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2004_848"
          x1="10.0001"
          x2="10.0001"
          y1="1.66663"
          y2="18.3333"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2004_848">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
